import styled from 'styled-components';
import { theme } from '../theme';

export const BlockUserModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BlockModalOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
`;

export const BlockModalContent = styled.div`
  position: relative;
  background: ${theme.colors.background.card};
  border-radius: ${theme.borderRadius.xl};
  box-shadow: ${theme.shadows.heavy};
  width: 90%;
  max-width: 450px;
  z-index: 1001;
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    width: 95%;
  }
`;

export const BlockModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${theme.spacing.lg};
  border-bottom: 1px solid ${theme.colors.border.light};
`;

export const BlockModalTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  color: ${theme.colors.text.primary};
  margin: 0;
`;

export const BlockModalClose = styled.button`
  background: none;
  border: none;
  font-size: 1.5rem;
  color: ${theme.colors.text.secondary};
  cursor: pointer;
  padding: ${theme.spacing.xs};
  line-height: 1;
  transition: color ${theme.transitions.fast};
  
  &:hover {
    color: ${theme.colors.text.primary};
  }
`;

export const BlockForm = styled.form`
  padding: ${theme.spacing.lg};
`;

export const BlockFormGroup = styled.div`
  margin-bottom: ${theme.spacing.md};
`;

export const BlockLabel = styled.label`
  display: block;
  font-size: 0.875rem;
  font-weight: 500;
  color: ${theme.colors.text.primary};
  margin-bottom: ${theme.spacing.xs};
`;

export const BlockTextarea = styled.textarea`
  width: 100%;
  padding: ${theme.spacing.sm} ${theme.spacing.md};
  border: 1px solid ${theme.colors.border.medium};
  border-radius: ${theme.borderRadius.md};
  font-size: 0.875rem;
  background: ${theme.colors.background.primary};
  color: ${theme.colors.text.primary};
  font-family: inherit;
  resize: vertical;
  min-height: 100px;
  transition: all ${theme.transitions.normal};
  
  &:focus {
    outline: none;
    border-color: ${theme.colors.primary};
    box-shadow: 0 0 0 2px rgba(255, 140, 66, 0.1);
  }
  
  &::placeholder {
    color: ${theme.colors.text.muted};
  }
`;

export const BlockFormActions = styled.div`
  display: flex;
  gap: ${theme.spacing.sm};
  margin-top: ${theme.spacing.lg};
  justify-content: flex-end;
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    flex-direction: column-reverse;
  }
`;

export const BlockConfirmButton = styled.button`
  padding: ${theme.spacing.sm} ${theme.spacing.lg};
  background: ${theme.colors.error};
  color: ${theme.colors.text.light};
  border: none;
  border-radius: ${theme.borderRadius.md};
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all ${theme.transitions.normal};
  
  &:hover {
    background: #c82333;
    transform: translateY(-1px);
    box-shadow: ${theme.shadows.medium};
  }
  
  &:active {
    transform: translateY(0);
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    width: 100%;
  }
`;






